export const STORE_NOTIFICATION = 'store/notification'
